import { render, staticRenderFns } from "./emotionStatisticList.vue?vue&type=template&id=fe545420"
import script from "./emotionStatisticList.vue?vue&type=script&lang=js"
export * from "./emotionStatisticList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports